var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReputationStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4307 5.99977L8.96069 1.15977C8.67069 0.209766 7.33069 0.209766 7.05069 1.15977L5.57069 5.99977H1.12069C0.150691 5.99977 -0.249309 7.24977 0.540691 7.80977L4.18069 10.4098L2.75069 15.0198C2.46069 15.9498 3.54069 16.6998 4.31069 16.1098L8.00069 13.3098L11.6907 16.1198C12.4607 16.7098 13.5407 15.9598 13.2507 15.0298L11.8207 10.4198L15.4607 7.81977C16.2507 7.24977 15.8507 6.00977 14.8807 6.00977H10.4307V5.99977Z",
    fill: "#282860"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReputationStar);
export default __webpack_public_path__ + "static/media/reputationStar.a556058e739a83229f94dc10e581a1be.svg";
export { ForwardRef as ReactComponent };